import { createFileRoute } from '@tanstack/react-router';

import { F29ColaView } from '@/features/f29/components/f29-cola/f29-cola-view';

export const Route = createFileRoute('/_app/f29/cola')({
  component: F29ColaView,
});
